import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { MealMonitoringFilterEntity } from '../../domain/entities/MealMonitoringFilterEntity'
import type { MealMonitoringFilterEntity as MealMonitoringFilterEntityDto } from '../../domain/entities/MealMonitoringFilterEntity'

export class MealMonitoringFilterModel extends MealMonitoringFilterEntity {
  constructor(dataDto: MealMonitoringFilterEntityDto) {
    super()
    mapEntityProperties<MealMonitoringFilterEntity>(this, dataDto)
  }
}
